import urljoin from 'url-join'
import ServicesUtils from '@/utils/servicesUtils'
import axios from 'axios'
import OneSignalUtils from '@/utils/oneSignalUtils'

/**
 * @param {number|string} cityId 
 * @param {number|string} userId 
 * @param {string} [token] 
 */
async function getUser (cityId, userId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'users', userId.toString())
    const response = await axios.get(url, {headers: { Authorization: `Bearer ${token}` }})

    return response.data
}

/**
 * @param {number|string} cityId 
 * @param {Object} user 
 * @param {string} [token] 
 */
async function updateUser (cityId, user, token)
{
    if (!user.oneSignalUserId)
    {
        user.oneSignalUserId = await OneSignalUtils.getUserId()
    }

    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'users')
    const response = await axios.patch(url, user, {headers: { Authorization: `Bearer ${token}` }})

    return response.data
}

export default { getUser, updateUser }


// WEBPACK FOOTER //
// ./src/services/users.js